import React from 'react';
import '../../../styles/CarelonRx/header.css';

interface HeaderProps {
  showLogout?: boolean;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({ showLogout = false, onLogout }) => {
  return (
    <header className="crx-header">
      <div className="header-container">
        <div className="brand">
          <a href="#" id="homeLink" aria-label="CarelonRx Home">
            <img 
              src="/assets/carelonRx/images/logo-carelonrx-color.png" 
              alt="CarelonRx" 
              className="logo-image"
            />
          </a>
        </div>
        
        {showLogout && onLogout && (
          <div className="header-actions">
            <button 
              onClick={onLogout}
              className="logout-button"
              aria-label="Logout"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
